import { RefObject } from 'react';
import { FormikProps } from 'formik';
import styles from './form.module.scss';
import { FormValues } from '@components/shared/forms/tech-due-diligence-form/form.config';

export type RequiredFieldName = 'fullName' | 'email';

type GuidedFormFieldProps = {
  name: RequiredFieldName;
  label: string;
  placeholder: string;
  formik: FormikProps<FormValues>;
  guidedField: RequiredFieldName | null;
  inputRef: RefObject<HTMLInputElement>;
};

const GuidedFormField = ({ name, label, placeholder, formik, guidedField, inputRef }: GuidedFormFieldProps) => {
  const isEmpty = !formik.values[name].trim();
  const isGuided = guidedField === name && isEmpty;
  const error = formik.errors[name];
  const showAsInvalid = !isEmpty && formik.touched[name] && !!error;

  return (
    <div
      className={`${styles.form__field} ${
        isGuided ? styles.form__field_required : showAsInvalid ? styles.form__field_invalid : ''
      }`}
    >
      <label htmlFor={name} className={styles.required}>
        {label}
      </label>
      <input id={name} type="text" placeholder={placeholder} {...formik.getFieldProps(name)} ref={inputRef} />
      {isGuided ? (
        <span className={styles.form__field_hint}>{error}</span>
      ) : showAsInvalid ? (
        <span className={styles.form__field_error}>{error}</span>
      ) : (
        ''
      )}
    </div>
  );
};

export default GuidedFormField;
